/**
 * Computes the new balance after an adjustment, rounded to 4 decimal places.
 */
export function computeNewBalance(currentBalance: number, adjustment: number): number {
  return parseFloat((currentBalance + adjustment).toFixed(4));
}

/**
 * Validates a wallet adjustment.
 * Amount must be non-zero, reason must not be empty, and resulting balance must be >= 0.
 */
export function isWalletAdjustmentValid(
  amount: number,
  reason: string,
  currentBalance: number,
): boolean {
  const newBalance = computeNewBalance(currentBalance, amount);
  return amount !== 0 && reason.trim().length > 0 && newBalance >= 0;
}
